import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';

export default class TermsPage extends Page {
  view() {
    const baseUrl = app.forum.attribute('baseUrl') || '';

    return (
      <div className="TermsPage">
        <div>
          <div className="user-terms-wrapper">
            <h2>用户协议</h2>
    <p> 在你决定成为上海日报社产品（包括但不限于SHANGHAIDAILY品牌、SHINE品牌和CITY NEWS
      SERVICE品牌，以下简称为上海日报社产品）的注册用户之前，请仔细阅读用户协议和隐私条款。我们以你的接受为前提向你提供上海日报社产品相关服务。你对网站或应用程序的使用构成你对本用户协议的接受。</p>
    <p> 上海日报社保留自行决定在任何时候变更、修改、增加或删除本协议条款部分或全部内容的权利。用户有责任定期查看更新的协议内容。用户在更新的协议条款发布之后继续使用上海日报社产品，即表示用户同意且接受该等更新。</p>
    <h3>通用规则</h3>
    <p> 本用户协议描述了你使用上海日报社产品服务的条款和条件。注册成为上海日报社产品用户或使用上海日报社产品相关服务，即表示你同意遵守本用户协议的所有条款。你同意根据用户协议和隐私政策使用网站或应用程序。</p>
    <p> 您理解并同意上海日报社有权基于自身经营策略的调整随时变更、中断或终止部分或全部的服务。</p>
    <h3>账户注册和使用</h3>
    <p> 你无需注册也可使用部分上海日报社产品服务（如浏览新闻、资讯），但某些功能和/或某些单项服务项目（评论留言、社区发帖跟帖等）将要求你按照国家相关法律法规的规定，提供真实的身份信息实名注册并登录后方可使用。</p>
    <p> 你应当使用真实、准确、合法、有效的身份信息注册账号并注意及时更新。注册成功后将获得一个账号。你可自主选择昵称、上传头像，昵称和头像经上海日报社审核通过后显示在前端。</p>
    <p> 你的用户账号由你自行负责保管。你应当对以你的用户账号进行的所有活动和事件负法律责任。如用户违反本协议内容，上海日报社有权对用户账号进行暂停使用、注销或停止提供服务等处理，由此导致的损失由你自行承担。</p>
    <h3>用户行为规范</h3>
    <p> 你应对在注册成为上海日报社产品用户时所填写的注册信息的真实性、准确性、合法性、有效性承担全部责任，如你注册信息虚假、不合法、不准确或无效给上海日报社或第三方造成损害的，你应当依法予以赔偿。</p>
    你有义务保证你的注册账号安全并不得将账号、密码转让或出借予他人使用，他人利用你的密码和账号所进行的一切活动引起的任何损失或损害，由你自行承担全部责任，上海日报社不承担任何责任。
    <p>
      你在使用上海日报社产品的过程中所创作、复制、上传、发布、传播、转载的任何内容（包括但不限于文字、语音、图片、视频、图文、图表、漫画、网页链接等），不得逾越法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等“七条底线”，不得发表含有下列信息的内容：
    </p>
    <p> (一) 反对宪法确定的基本原则的；</p>
    <p> (二) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
    <p> (三) 损害国家荣誉和利益的；</p>
    <p> (四) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p> (五) 煽动地域歧视、地域仇恨的；</p>
    <p> (六) 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>
    <p> (七) 破坏国家宗教政策，宣扬邪教和迷信的；</p>
    <p> (八) 侮辱和歧视性别、年龄、种族、出身、国别、性取向、生理缺陷的；</p>
    <p> (九) 散布谣言，扰乱社会秩序、破坏社会稳定的；</p>
    <p> (十) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p> (十一) 侮辱或诽谤他人，侵害他人合法权益的；</p>
    <p> (十二) 对他人进行暴力恐吓、威胁，实施人肉搜索的；</p>
    <p> (十三) 未获得未满18周岁未成年人法定监护人的书面同意，传播该未成年人的隐私信息的；</p>
    <p> (十四) 散布污言秽语，损坏社会公序良俗的；</p>
    <p> (十五) 侵犯他人知识产权的；</p>
    <p> (十六) 未经“社区”网站的同意散布非法商业广告，或类似的商业招揽信息；</p>
    <p> (十七) 与所评论的信息毫无关系的；</p>
    <p> (十八) 所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；</p>
    <p> (十九) 歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；</p>
    <p> (二十)以非法民间组织名义活动的；</p>
    <p> (二十一)法律、法规和规章禁止传播的其他信息。</p>
    <p>
      有违上述内容者，上海日报社有权不经你同意，直接视情况采取预先警示、拒绝发布、修改、屏蔽、删除你发布的信息或短期禁止、永久停止其账号使用权限等管理措施。对涉嫌违法犯罪的用户言论上海日报社将保存在案、并在接受有关政府部门调查时如实报告。
    </p>
    <p> 你不得利用上海日报社产品制作、复制、上载、发布、传播、转载如下内容：</p>
    <p> (一) 虚假信息；</p>
    <p> (二) 含有任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的、有性或性暗示以及任何其他类似信息；</p>
    <p> (三) 骚扰、垃圾广告；</p>
    <p> (四) 涉及他人隐私、个人信息或资料的任何信息；</p>
    <p> (五) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权益的任何信息；</p>
    <p> (六) 含有其他干扰上海日报社正常运营的信息。</p>
    <h3>用户个人信息保护</h3>
    <p> 上海日报社深知个人信息对你的重要性，并会尽全力保护你的个人信息安全可靠。关于上海日报社产品如何收集、使用、存储和保护你的个人信息以及你享有的权利，详见《上海日报社隐私政策》中的相关约定。</p>
    <h3>知识产权</h3>
    <p>
      上海日报社产品在服务中提供的任何内容（包括但不限于文字、图片、图形、音频、视频、数据、计算机软件、商业标识、版面设计、排版方式等）的知识产权（著作权、商标权、专利权、商业秘密等）和其他衍生权利均归上海日报社所有。未经上海日报社书面许可，任何人不得使用。
    </p>
    <p>
      你在使用上海日报社产品服务过程中上传、发布的全部内容的知识产权归属你或原始著作权人所有。你同意并确认授予上海日报社享有你上传发布的全部内容在全球范围内、免费、非独家使用、可再许可的权利（包括但不限于复制权、信息网络传播权、改编权、汇编权、修改权、翻译权、制作衍生品、表演和展示等权利），使用范围包括但不限于在当前或其他网站、应用程序、产品或终端设备等。
    </p>
    <p> 用户在上海日报社产品上发表、上传或提供的内容若非用户原创，用户应保证其已取得著作权人或相关权利人的合法授权。</p>
    <p>
      对于用户在上海日报社产品上发布的内容仅代表用户自己的立场和观点，并不代表上海日报社的立场和观点，用户作为内容的发表者或上传者，应自行对其发表或上传的内容引发的知识产权、名誉权、隐私权等纠纷、损失承担相关法律责任并应由用户自行负责妥善解决。上海日报社不对此承担任何法律及连带责任。
    </p>
    <h3>免责声明</h3>
    <p>
      在使用上海日报社产品提供的服务过程中，对于因不可抗力或上海日报社不能控制的原因造成的网络服务中断或其它缺陷，上海日报社将努力在第一时间及时修复，但因不可抗力造成的损失，上海日报社不承担任何责任。但将尽力减少因此而给用户造成的损失和影响。
    </p>
    <p> 上海日报社对所有服务及其内容的真实性、准确性、完整性、有效性、时效性不作任何性质的担保或保证。你应谨慎判断并自担风险，上海日报社不对因使用服务内容所引致的任何损失承担任何责任。</p>
    <p> 对于因上海日报社向用户赠送的任何产品或者服务、免费提供的各项网络服务的本身质量缺陷及其引发的任何损失，上海日报社无需承担任何责任。</p>
    <p> 上海日报社产品提供服务的内容可能涉及由第三方提供，你应当知晓并按照第三方服务协议使用第三方服务。第三方的内容、产品、服务、广告和其他任何信息均需由你自行判断并承担风险，上海日报社并不就此而对你或任何第三方承担任何责任。
    </p>
    <h3>法律责任</h3>
    <p>
      用户理解并认可，上海日报社产品为提供信息分享、传播及获取的平台，用户在使用上海日报社产品时，请用户自行对内容加以判断，并承担因使用内容而引起的所有风险。用户须为自己注册账户下的一切行为负责，包括用户所发表内容的真实性、合法性、准确性、有效性，以及承担因账号使用、运营、管理行为产生的结果。上海日报社产品无法且不会对因用户的行为而导致的风险损失或损害承担责任。如果用户发现任何人违反本协议规定或以其他不当的方式使用上海日报社产品服务，请立即举报或投诉，上海日报社将依法进行处理。
    </p>
    <p> 对违反有关法律法规或本协议规定的行为，上海日报社将依法律规定及上述规则等加以合理判断进行处理，对违法违规的任何人士采取适当的法律行动，并依据法律法规保存有关信息并向有关部门报告等。</p>
    <p>
      若用户上传、发布的内容或其他在上海日报社产品上从事的行为侵害他人利益并引发第三方的任何索赔、要求或赔偿的，需由用户承担全部法律责任。若因此给上海日报社或第三方造成任何损失，用户应负责赔偿并使之免受损害，损失包括但不限于诉讼费用、律师费用、和解费用、罚款或生效法律文书中规定的损害赔偿金额及其他直接或间接支出费用。
    </p>
    <p>
      若上海日报社发现有用户不当使用用户账号或有用户账号被他人举报投诉时，上海日报社有权不经通知随时删除相关内容，并视用户行为情节对违规账号进行处理，处理方式包括但不限于警告、删除部分或全部订阅用户、限制或禁止使用全部或部分功能、账号封禁甚至注销，并有权视具体情况而公告处理结果。
    </p>
    <h3>协议修改</h3>
    <p>
      由于上海日报社产品是不断发展的，或者因有关法律、法规及规范性文件的变更，上海日报社有权随时更改、添加或删除本用户协议的某些部分，或者对上海日报社产品添加新的使用条件。在这种情况下，我们将发布修订版的用户协议。最新版的用户协议发布后立即生效。你有责任定期查看这些条款。你在最新版本的用户协议生效之后继续使用上海日报社产品即表示你接受并同意此类更改。
    </p>
    <h3>终止</h3>
    <p> 我们可能随时终止或取消你对上海日报社产品的访问。在这种终止的情况下，你在网站或应用程序上存储的任何信息可能以后都无法检索。</p>
    <p> 你可以随时通过发送电子邮件至online@shanghaidaily.com向客户服务提出终止你的账户。你应对由此产生的所有费用负责。</p>
    <h3>法律适用与管辖</h3>
    <p> 本协议受中华人民共和国法律的管辖。</p>
    <p> 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向上海日报社所在地的人民法院提起诉讼。</p>
    <p> 如果本协议的任何条款被裁定为无效或不可执行，则删除该条款，但其余条款仍应予以执行。</p>
    <h3>其他</h3>
    <p> 如果你对协议有任何疑问、意见或建议，可通过online@shanghaidaily.com与我们联系。</p>
    <p> 在法律规定的范围内本协议的最终解释权归上海日报社所有。</p>
  </div>

          <div className="user-terms-wrapper">
            <h2>User Agreement</h2>
    <p> Before you decide to become a registered user of Shanghai Daily products (including but not limited to the
      SHANGHAIDAILY brand, SHINE brand, and CITY NEWS SERVICE brand, hereinafter referred to as Shanghai Daily
      products), please carefully read the User Agreement and Privacy Terms. We provide you with services related to
      Shanghai Daily products on the condition that you accept them. Your use of the website or application constitutes
      your acceptance of this User Agreement.</p>
    <p> Shanghai Daily reserves the right to change, modify, add, or delete parts or all of the contents of this
      agreement at any time at its own discretion. It is the user's responsibility to regularly review the updated
      agreement terms. By continuing to use Shanghai Daily products after the publication of the updated agreement
      terms, the user agrees to and accepts such updates.</p>
    <h3>General Rules</h3>
    <p> This User Agreement describes the terms and conditions for using the products and services of Shanghai Daily. By
      registering as a user of Shanghai Daily products or using related services, you agree to comply with all the terms
      of this User Agreement. You agree to use the website or application in accordance with the User Agreement and
      Privacy Policy.</p>
    <p> You understand and agree that Shanghai Daily has the right to change, interrupt, or terminate part or all of its
      services at any time based on adjustments to its business strategy.</p>
    <h3>Account Registration and Use</h3>
    <p> You can use certain Shanghai Daily products and services without registration (such as browsing news and
      information). However, some features and/or specific services (such as commenting, posting, and replying in the
      community) require you to provide real identity information for registration and log in according to relevant
      national laws and regulations before they can be used.</p>
    <p> You should use real, accurate, legal, and valid identity information to register an account and pay attention to
      updating it in a timely manner. Once registration is successful, you will obtain an account. You can choose a
      nickname and upload an avatar on your own. After being approved by Shanghai Daily, your nickname and avatar will
      be displayed on the front end.</p>
    <p> You are responsible for safeguarding your user account. You should bear legal responsibility for all activities
      and events conducted under your user account. If a user violates the content of this agreement, Shanghai Daily has
      the right to suspend, cancel the user account, or stop providing services, and any resulting losses shall be borne
      by you.</p>
    <h3>User Behavior Code of Conduct</h3>
    <p> You are fully responsible for the authenticity, accuracy, legality, and validity of the registration information
      you provide when signing up as a user of Shanghai Daily's products. If your registration information is false,
      illegal, inaccurate, or invalid and causes damage to Shanghai Daily or a third party, you are legally obligated to
      compensate for the damages.</p>
    <p>You are obligated to ensure the security of your registered account and must not transfer or lend your account or
      password to others. Any loss or damage resulting from activities conducted using your password and account by
      others will be solely your responsibility, and Shanghai Daily will not assume any liability.</p>
    <p>
      In the process of using Shanghai Daily's products, any content you create, replicate, upload, publish, transmit,
      or reproduce (including but not limited to text, voice, images, videos, graphics, charts, cartoons, web links,
      etc.) must not violate laws and regulations, the socialist system, national interests, the legitimate rights and
      interests of citizens, social public order, moral norms, and the authenticity of information, which are known as
      the "seven bottom lines." You must not publish content containing any of the following types of information: </p>
    <p> 1. Opposing the basic principles established by the Constitution;</p>
    <p> 2. Endangering national security, disclosing state secrets, subverting state power, or undermining national
      unity;</p>
    <p> 3. Damaging the honor and interests of the nation;</p>
    <p> 4. Inciting ethnic hatred or discrimination, undermining national unity;</p>
    <p>5. Inciting regional discrimination or hatred;</p>
    <p>6. Inciting illegal assemblies, associations, marches, demonstrations, or gathering crowds to disturb social
      order;</p>
    <p> 7. Undermining state religious policies, promoting cults and superstitions;</p>
    <p> 8. Insulting or discriminating based on gender, age, race, origin, nationality, sexual orientation, or physical
      disabilities;</p>
    <p>9. Spreading rumors, disrupting social order, or undermining social stability;</p>
    <p>10. Spreading obscene, pornographic, gambling, violent, murderous, terroristic content, or inciting criminal
      acts;</p>
    <p> 11. Insulting or defaming others, infringing on others' legal rights and interests;</p>
    <p> 12. Conducting violent threats or intimidation against others</p>
    <p> 13. Disseminating the private information of minors under the age of 18 without the written consent of their
      legal guardians;</p>
    <p>14. Spreading vulgar language or obscenities that damage social order and good customs;</p>
    <p>15. Infringing on others' intellectual property rights;</p>
    <p>16. Distributing illegal commercial advertisements or similar solicitation messages without the consent of the
      "community" website;</p>
    <p>17. Publishing content that is irrelevant to the discussed information;</p>
    <p>18. Publishing meaningless information or deliberately using character combinations to evade technical review;
    </p>
    <p>19. Distorting, vilifying, desecrating, or denying the deeds and spirit of heroes and martyrs, and insulting,
      defaming, or otherwise infringing on the name, portrait, reputation, and honor of heroes and martyrs</p>
    <p>20. Acting under the name of an illegal civil organization;</p>
    <p>21. Spreading other information that is prohibited by laws, regulations, and rules.</p>
    <p>
      If you violate the aforementioned content, Shanghai Daily has the right, without your consent, to directly take
      management measures such as issuing a prior warning, refusing to publish, modifying, blocking, deleting your
      posted information, or temporarily banning or permanently stopping your account usage rights depending on the
      situation. If a user's speech is suspected of violating the law or committing a crime, Shanghai Daily will keep a
      record and truthfully report to the relevant government departments during investigations. </p>
    <p>You may not use Shanghai Daily products to create, copy, upload, publish, disseminate, or reproduce the following
      content:</p>
    <p>1. False information;</p>
    <p>2. Content that is harassing, defamatory, abusive, threatening, vulgar, obscene, sexually explicit, or
      suggestive, or any other similar information;</p>
    <p>3. Harassment or spam advertisements;</p>
    <p>4. Any information involving someone else's privacy, personal information, or data;</p>
    <p>5. Any information that infringes upon another's rights to reputation, likeness, intellectual property, trade
      secrets, or other legal rights;</p>
    <p>6. Content containing other information that interferes with the normal operations of Shanghai Daily.</p>
    <h3>Protection of User Personal Information</h3>
    <p>Shanghai Daily understands the importance of your personal information and is committed to ensuring that your
      personal information is secure and protected. For details on how Shanghai Daily products collect, use, store, and
      protect your personal information, as well as the rights you have, please refer to the relevant provisions in the
      "Shanghai Daily Privacy Policy".</p>
    <h3>Intellectual Property</h3>
    <p>
      Intellectual property rights (including but not limited to copyright, trademark rights, patent rights, trade
      secrets, etc.) and other derivative rights of any content provided in the services of Shanghai Daily products
      (including but not limited to text, images, graphics, audio, video, data, computer software, business identifiers,
      layout design, typographic arrangements, etc.) are owned by Shanghai Daily. Without written permission from
      Shanghai Daily, no one may use these materials. </p>
    <p>
      The intellectual property rights of all content that you upload and publish while using the services of Shanghai
      Daily products belong to you or the original copyright owner. You agree and acknowledge that you grant Shanghai
      Daily a free, non-exclusive, sublicensable right to use all content you upload and publish worldwide. This
      includes but is not limited to the rights to copy, disseminate over information networks, adapt, compile, modify,
      translate, create derivative works, perform, and display, and can be used in, but not limited to, current or other
      websites, applications, products, or terminal devices. </p>
    <p>If the content published, uploaded, or provided by users on Shanghai Daily products is not originally created by
      the user, the user must ensure that they have obtained legal authorization from the copyright owner or relevant
      rights holder.</p>
    <p>
      The content posted by users on Shanghai Daily products represents only the user's own views and opinions and does
      not represent the views and opinions of Shanghai Daily. As the publisher or uploader of the content, the user
      shall bear legal responsibility for any intellectual property disputes, reputation rights, privacy rights, and
      other losses caused by the content they publish or upload, and it is the user's responsibility to properly resolve
      these issues. Shanghai Daily does not assume any legal or joint liability for these matters. </p>
    <h3>Disclaimer</h3>
    <p>
      During the use of services provided by Shanghai Daily, Shanghai Daily will strive to repair any interruptions or
      other defects in the network services caused by force majeure or reasons beyond the control of Shanghai Daily as
      soon as possible. However, Shanghai Daily will not be liable for any losses caused by force majeure, but will make
      efforts to minimize the losses and impacts on users. </p>
    <p> Shanghai Daily makes no warranties or guarantees of any kind regarding the authenticity, accuracy, completeness,
      effectiveness, or timeliness of all services and their content. You should exercise caution and bear all risks
      yourself; Shanghai Daily will not be liable for any losses incurred due to the use of the service content.</p>
    <p> Shanghai Daily will not be liable for any losses caused by any defects in the quality of any products or
      services gifted to users or provided free of charge as part of the online services.</p>
    <p> The content of the services provided by Shanghai Daily products may involve third-party providers. You should be
      aware of and use third-party services in accordance with the third-party service agreements. You are responsible
      for assessing and taking risks associated with the content, products, services, advertising, and any other
      information provided by third parties. Shanghai Daily bears no responsibility to you or any third party in this
      regard.
    </p>
    <h3>Legal Liability</h3>
    <p>
      Users understand and acknowledge that Shanghai Daily products serve as platforms for sharing, disseminating, and
      obtaining information. When using Shanghai Daily products, users should judge the content themselves and bear all
      risks associated with the use of such content. Users are responsible for all activities conducted under their
      registered accounts, including the authenticity, legality, accuracy, and validity of the content they post, and
      must bear the consequences of the use, operation, and management of their accounts. Shanghai Daily products cannot
      and will not be liable for any risks, losses, or damages resulting from users' actions. If a user discovers anyone
      violating this agreement or using Shanghai Daily services inappropriately, they should immediately report or
      complain, and Shanghai Daily will handle it according to the law.
    </p>
    <p> Shanghai Daily will make reasonable judgments and take appropriate legal actions against anyone who violates
      relevant laws, regulations, or the provisions of this agreement, in accordance with legal requirements and the
      aforementioned rules. It will also preserve relevant information and report to the appropriate authorities as
      required by law.</p>
    <p>
      If the content uploaded or posted by users, or any other actions taken on Shanghai Daily products, infringe upon
      the interests of others and lead to any claims, demands, or compensation from third parties, the user shall bear
      all legal responsibilities. If this causes any loss to Shanghai Daily or third parties, the user shall be
      responsible for compensation and ensuring they are unharmed. Losses include, but are not limited to, litigation
      costs, attorney fees, settlement fees, fines, or damages specified in legally effective documents, as well as
      other direct or indirect expenses.
    </p>
    <p>
      If Shanghai Daily discovers that a user is improperly using their account or if a user's account has been reported
      or complained about by others, Shanghai Daily reserves the right to delete the relevant content without notice and
      to take action against the offending account based on the severity of the user's actions. Measures may include,
      but are not limited to, warnings, deletion of some or all subscriptions, restriction or prohibition of the use of
      all or part of the functions, account suspension, or even cancellation, and Shanghai Daily reserves the right to
      announce the results depending on the specific circumstances.
    </p>
    <h3>Agreement Modification</h3>
    <p>
      As Shanghai Daily products are continuously evolving, or due to changes in relevant laws, regulations, and
      normative documents, Shanghai Daily reserves the right to modify, add, or remove parts of this User Agreement at
      any time, or to impose new conditions on the use of Shanghai Daily products. In such cases, we will publish a
      revised version of the User Agreement. The latest version of the User Agreement becomes effective immediately upon
      publication. It is your responsibility to regularly review these terms. Your continued use of Shanghai Daily
      products after the effectiveness of the latest version of the User Agreement indicates your acceptance and
      agreement to such changes.
    </p>
    <h3>Termination</h3>
    <p> We may terminate or cancel your access to Shanghai Daily products at any time. In the event of such termination,
      any information you have stored on the website or application may become irretrievable.</p>
    <p>You may terminate your account at any time by sending an email to&nbsp;online@shanghaidaily.com&nbsp;to customer service.
      You are responsible for all charges incurred up to the time the account is terminated.</p>
    <h3>Legal Application and Jurisdiction</h3>
    <p> This agreement is governed by the laws of the People's Republic of China.</p>
    <p> If there is any dispute regarding the content of this agreement or its execution, both parties should try to
      resolve it through friendly negotiation; if negotiation fails, either party may bring a lawsuit to the people's
      court at the location of Shanghai Daily.</p>
    <p> If any provision of this agreement is found to be invalid or unenforceable, that provision shall be removed, but
      the remaining provisions shall still be enforced.</p>
    <h3>Other</h3>
    <p>If you have any questions, comments, or suggestions about the agreement, you can contact us
      via&nbsp;online@shanghaidaily.com.</p>
    <p> Shanghai Daily reserves all rights.</p>
  </div>
</div>
      </div>
    );
  }
}
